import * as React from 'react';
import { ItemInfoLabel, ItemInfoLabelWithData } from 'components';
require('./style.css');

interface IProps {
	name: string;
	followersCount?: string;
	followersText?: string;
	description: string;
	location?: string;
	onClick?: any;
}
/**
 *
 * @param props
 */
export const CardItemProfileInfo = (props: IProps) => {
	const { name, followersCount, onClick, location, followersText } = props;
	const onViewProfileClick = (e) => {
		if (onClick) {
			onClick(e);
		}
	};

	return (
		<div className="profileItemCardInfo itemDetail" onClick={(e) => onViewProfileClick(e)}>
			<span className="name">{name}</span>
			{location ? <ItemInfoLabel text={location} /> : null}
			{followersCount && followersText ? <ItemInfoLabelWithData text={followersText} data={followersCount} /> : null}
		</div>
	);
};
